import { ELIGIBILITIES_ORDER, DYNAMIC_CART } from '../../constants/endpoints';
import { getEligibleItems, getIneligibleItems } from '../../services/order-info/utils';

export const SET_ITEMS = 'SET_ITEMS';
export const SET_NA_ITEMS = 'SET_NA_ITEMS';
export const SET_ITEMS_BY_RETURN_DATE = 'SET_ITEMS_BY_RETURN_DATE';
export const SET_ITEMS_BY_RETURN_DAY = 'SET_ITEMS_BY_RETURN_DAY';
export const SET_ITEMS_GROUPING_ITEMS = 'SET_ITEMS_GROUPING_ITEMS';
export const SET_BUNDLE_ITEMS = 'SET_BUNDLE_ITEMS';
export const SET_ITEM_RETURN_QTY_BY_DAY = 'SET_ITEM_RETURN_QTY_BY_DAY';
export const SET_RETURN_LABELS = 'SET_RETURN_LABELS';
export const SET_RETAILER_ELIGIBILITIES = 'SET_RETAILER_ELIGIBILITIES';
export const SET_IS_FETCHING_ELIGIBILITIES = 'SET_IS_FETCHING_ELIGIBILITIES';

export const setItems = (items) => ({
  type: SET_ITEMS,
  data: {
    items,
  },
});

export const setNaItems = (naItems) => ({
  type: SET_NA_ITEMS,
  data: {
    naItems,
  },
});

export const setItemsByReturnDate = (itemsByReturnDate) => ({
  type: SET_ITEMS_BY_RETURN_DATE,
  data: {
    itemsByReturnDate,
  },
});

export const setItemsByReturnDay = (itemsByReturnDay) => ({
  type: SET_ITEMS_BY_RETURN_DAY,
  data: {
    itemsByReturnDay,
  },
});

export const setItemsGroupingItems = (itemGroupingItems) => ({
  type: SET_ITEMS_GROUPING_ITEMS,
  data: {
    itemGroupingItems,
  },
});

export const setBundleItems = (bundleItems) => ({
  type: SET_BUNDLE_ITEMS,
  data: {
    bundleItems,
  },
});

export const setItemReturnQtyByDay = (itemReturnQtyByDay) => ({
  type: SET_ITEM_RETURN_QTY_BY_DAY,
  data: {
    itemReturnQtyByDay,
  },
});

export const setReturnLabels = (returnLabels) => ({
  type: SET_RETURN_LABELS,
  data: {
    returnLabels,
  },
});

export const setRetailerEligibilities = (retailerEligibilities) => ({
  type: SET_RETAILER_ELIGIBILITIES,
  data: {
    retailerEligibilities,
  },
});

const refreshItemEligibilities = ({ incomingItems, currentItems }) =>
  currentItems.map((currentItem) => {
    const itemToRefresh = incomingItems.find(
      (incomingItem) => `${incomingItem.item_id}` === `${currentItem.item_id}`,
    );

    if (!itemToRefresh || !itemToRefresh.eligibilities) {
      return currentItem;
    }

    const newEligibilities = {};

    itemToRefresh.eligibilities.forEach((eligibility) => {
      const {
        action_type: actionType,
        eligibility_message: eligibilityMessage,
        eligible,
      } = eligibility;

      newEligibilities[actionType] = {
        type: actionType,
        is_eligible: eligible,
        message: eligibilityMessage?.value,
        message_token: eligibilityMessage?.token,
      };
    });

    return {
      ...currentItem,
      item_eligibilities: newEligibilities,
    };
  });

export const refreshOrderEligibilities = (cartItems) => async (dispatch, getState) => {
  try {
    const {
      page: { locale, overrideCode, productType } = {},
      retailerSettings: { name: retailerMoniker } = {},
      returnsSettings: { [productType]: { ignoreReturnLabels = false } = {} } = {},
      landingPage: { landingForm: { email } } = {},
      orderInfo: { currentOrderNumber: orderNumber } = {},
      orderService: { items, naItems, retailerEligibilities } = {},
    } = getState();

    const response = await fetch(ELIGIBILITIES_ORDER, {
      method: 'POST',
      headers: {
        'X-Retailer-Moniker': retailerMoniker,
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        order_number: orderNumber,
        email,
        locale,
        eligibility_override_code: overrideCode,
        cart: {
          items: cartItems.map((item) => ({
            item_id: `${item.item_id}`,
            action_type: item.action_type,
            quantity: item.return_qty,
          })),
        },
      }),
    });
    const data = await response.json();
    const refreshedItems = refreshItemEligibilities({
      incomingItems: data.items,
      currentItems: [...items, ...naItems],
    });

    await dispatch(setItems(getEligibleItems(refreshedItems, retailerEligibilities, 'some')));
    return dispatch(
      setNaItems(
        getIneligibleItems(refreshedItems, retailerEligibilities).filter(
          (item) => item.remaining_qty > 0 || ignoreReturnLabels,
        ),
      ),
    );
  } catch (err) {
    return console.log(err);
  }
};

export const fetchBundleItems = (cartItems) => async (dispatch, getState) => {
  try {
    const {
      retailerSettings: { name: retailerMoniker } = {},
      orderInfo: { currentOrderNumber: orderNumber } = {},
    } = getState();

    const response = await fetch(DYNAMIC_CART(retailerMoniker), {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        items: cartItems.map((item) => ({
          orderNumber,
          itemId: `${item.item_id}`,
          quantity: item.return_qty,
        })),
      }),
    });

    const data = await response.json();

    if (!data || !data.items || data.items.length === 0) {
      return dispatch(setBundleItems({}));
    }

    const bundleMapping = data.items.reduce((acc, item) => {
      acc[item.itemId] = item;
      return acc;
    }, {});
    await dispatch(setBundleItems(bundleMapping));
  } catch (err) {
    return console.log(err);
  }
};
